import { RequestTopics } from "services/topics";
import { Modal } from "components/ui/modal";
import useMqttApi from "hooks/use-mqtt-api";
import { UsbDataTransfer } from "types/mqtt-api";
import { useState } from "react";
import { toast } from "react-toastify";
import { TransferState } from "./transfer-state";
import { SuccessState } from "./success-state";
import { StartState } from "./start-state";
import { ErrorState } from "./error-state";
import { useTranslation } from "react-i18next";

export enum UsbTransferStates {
  Start = "Transfer data",
  Transfer = "Transferring data",
  Success = "Success",
  Error = "Error",
}

export const UsbTransferModal = ({ show, onClose }) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "settings.general_settings.usb_data_transfer",
  });

  const [screenState, setScreenState] = useState(UsbTransferStates.Start);

  const { data, error, fetch } = useMqttApi<UsbDataTransfer>({
    requestTopic: RequestTopics.TransferData,
    enabled: false,
    timeout: false,
    request: {
      status: "START",
    },
    onError: (error) => {
      setScreenState(UsbTransferStates.Error);
      toast.error(error.message, { autoClose: false });
    },
    onSuccess: () => {
      setScreenState(UsbTransferStates.Success);
      toast.success(t("success_message"));
    },
  });

  const onTransferCancel = () => {
    fetch({
      status: "STOP",
    });
    toast.info(t("cancel_message"));
    setScreenState(UsbTransferStates.Start);
    onClose();
  };

  const modalTitle = {
    [UsbTransferStates.Start]: t("start_modal.title"),
    [UsbTransferStates.Transfer]: t("transfer_modal.title"),
    [UsbTransferStates.Success]: t("success_modal.title"),
    [UsbTransferStates.Error]: t("error_modal.title"),
  };

  return (
    <Modal title={modalTitle[screenState]} show={show}>
      {screenState === UsbTransferStates.Start && (
        <StartState
          fetch={fetch}
          setScreenState={setScreenState}
          onClose={onClose}
        />
      )}
      {screenState === UsbTransferStates.Transfer && (
        <TransferState data={data} onCancel={onTransferCancel} />
      )}
      {screenState === UsbTransferStates.Success && (
        <SuccessState
          data={data}
          setScreenState={setScreenState}
          onClose={onClose}
        />
      )}
      {screenState === UsbTransferStates.Error && (
        <ErrorState
          error={error}
          setScreenState={setScreenState}
          onClose={onClose}
        />
      )}
    </Modal>
  );
};
